// @ts-nocheck
export const NEW_MESSAGE_HANDLER = "new_message";
export const ON_NEW_MESSAGE_HANDLER = "new_message";
export const DELETE_MESSAGE = "delete_message";
export const ON_DELETE_MESSAGE_EVENT = "delete_message";
export const EDIT_MESSAGE = "edit_message";
export const ON_EDIT_MESSAGE_EVENT = "edit_message";
export const ON_NEW_CHAT_ROOM = "new_chat_room";
export const UPDATE_CHAT_ROOM_STATUS = "update_chat_status";
export const UPDATE_MSG_STATUS = "update_msg_status";

export const JOIN_CHAT = "join_chat";
export const SETUP = "setup";